import Vue from 'vue'
import Vuex from 'vuex'
// 引入 axios
import axios from 'axios'
import qs from 'qs'
import http from '../utils/http'

Vue.use(Vuex)

const store = new Vuex.Store({
  // 定义状态
  state: {
    //学生信息集合
   studentList:{},

  },
  actions:{

  },
  mutations: {
    setRuleForm(state, payload) {

      Object.assign(state.studentList, payload);

      localStorage.setItem('ruleForm', JSON.stringify(payload));
    },
  },
  getters:{
  },
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js